module.exports = __webpack_public_path__ + "static/media/anna-win.1fda4f60.png";